import React from 'react';

function SkillsSection({ skills }) {
  const { languages, frameworkTools, libraries } = skills;
  
  return (
    <div className="skills-grid">
      <div className="skill-category">
        <h4>Languages</h4>
        <div className="cv-skills">
          {languages.map((skill, i) => (
            <li key={i}>{skill}</li>
          ))}
        </div>
      </div>
      <div className="skill-category">
        <h4>Framework/Tools</h4>
        <div className="cv-skills">
          {frameworkTools.map((skill, i) => (
            <li key={i}>{skill}</li>
          ))}
        </div>
      </div>
      <div className="skill-category">
        <h4>Libraries</h4>
        <div className="cv-skills">
          {libraries.map((skill, i) => (
            <li key={i}>{skill}</li>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SkillsSection; 